<template>
	<div class="PopAddBase">
		<el-dialog :visible.sync="dialogVisible" :lock-scroll="false">
			<div class="tianjiazizhanghao">
				<div class="pop-header">
					<div class="ph-title">
						<span v-if="ruleForm.id">修改知识库</span>
						<span v-else>添加知识库</span>
					</div>
					<div class="ph-close pointer" @click="close"></div>
				</div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="pop-body">
					<div class="cb-row">
						<div class="cbr-label">标题：</div>
						<div class="cbr-content">
							<el-form-item prop="title" class="form-item yanzhengma">
								<el-input v-model="ruleForm.title" class="input type-1" placeholder="请输入" clearable></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="cb-row" style="align-items: flex-start;">
						<div class="cbr-label">上传文件：</div>
						<div class="cbr-content">
							<el-form-item prop="fileUrl" class="form-item">
								<FileUpload class="upload-demo" 
								:fileType="fileType"
								listType="text"
								v-model="ruleForm.fileUrl" :limit="1" dir="fileUrl">
									<el-button size="small" type="primary">点击上传</el-button>
								</FileUpload>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div class="pop-footer">
					<div class="pf-cancel btn-fill" @click="close">取消</div>
					<div class="pf-confirm btn-fill" @click="submit">确定</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		AddBase,
		EditBase
	} from '../common/api.js'
	var that = {}
	var ruleForm = {
		fileType: 1, // 文件类型 1=图片 2=视频 3=pdf 4=word 5=excel 6=ppt 7=txt
		fileUrl: '', // 文件路径
		title: '', // 标题
		id: '', // id
	}
	export default {
		name: 'PopAddBase',//添加知识库
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				dialogVisible: false,
				ruleForm: {...ruleForm},
				rules: {
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}],
					fileUrl: [{
						required: true,
						message: '请上传文件',
						trigger: 'blur'
					}],
				},
				fileType: ["png", "jpg", "jpeg", 'mp4','avi','wmv', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf'],
				
				
			}
		},
		watch: {
			show: {
				handler: function(val) {
					this.dialogVisible = val
				},
				immediate: true
			},
			dialogVisible: {
				handler: function(val) {
					if (!val) {
						this.$refs.ruleForm.resetFields()
					}
					this.$emit('update:show', val)
				}
			},
			
		},
		filters: {
			getFileTypeFilter(v) {
				// 文件类型 1=图片 2=视频 3=pdf 4=word 5=excel 6=ppt 7=txt
				// fileType: ["png", "jpg", "jpeg", 'mp4','avi','wmv', 'pdf', 'word', 'excel', 'ppt', 'txt'],
				if (v == 'png' || v == 'jpg' || v == 'jpeg') {
					return 1
				} else if(v == 'mp4' || v == 'avi' || v == 'wmv') {
					return 2
				} else if(v == 'pdf') {
					return 3
				} else if(v == 'doc' || v == 'docx') {
					return 4
				} else if(v == 'xls' || v == 'xlsx') {
					return 5
				} else if(v == 'ppt' || v == 'pptx') {
					return 6
				} else if(v == 'txt') {
					return 7
				} else {
					return ''
				}
			}
			
		},
		created() {
			that = this
		},
		methods: {
			open(data) {
				if (!data) {
					this.ruleForm = {...ruleForm}
				} else {
					this.ruleForm.fileType = data.fileType // 文件类型 1=图片 2=视频 3=pdf 4=word 5=excel 6=ppt 7=txt
					this.ruleForm.fileUrl = data.fileUrl // 文件路径
					this.ruleForm.title = data.title // 标题
					this.ruleForm.id = data.id // id
				}
				this.dialogVisible = true
			},
			close() {
				this.dialogVisible = false
			},
			submit() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						if (!this.ruleForm.id) {
							let data = {
								fileType: '', // 文件类型
								fileUrl: this.ruleForm.fileUrl, // 文件路径
								title: this.ruleForm.title, // 标题
								id: this.ruleForm.id, // id
							}
							let name = data.fileUrl.substring(data.fileUrl.lastIndexOf(".") + 1,data.fileUrl.length)
							data.fileType = this.$options.filters['getFileTypeFilter'](name)
							
							console.log('data: ',data);
							
							AddBase(data).then(res => {
								this.toast({
									message: '添加成功',
									type: 'success'
								})
								this.close()
								this.$emit('addSuccess')
							})
						} else {
							let data = {
								fileType: '', // 文件类型
								fileUrl: this.ruleForm.fileUrl, // 文件路径
								title: this.ruleForm.title, // 标题
								id: this.ruleForm.id, // id
							}
							let name = data.fileUrl.substring(data.fileUrl.lastIndexOf(".") + 1,data.fileUrl.length)
							data.fileType = this.$options.filters['getFileTypeFilter'](name)
							console.log('data: ',data);
							
							EditBase(data).then(res => {
								this.toast({
									message: '修改成功',
									type: 'success'
								})
								this.close()
								this.$emit('editSuccess')
							})
						}
						
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.PopAddBase {
		.tianjiazizhanghao {
			min-width: 600px;
			// min-height: 396px;
			background: #FFFFFF;
			border-radius: 8px 8px 8px 8px;
			box-sizing: border-box;
			padding: 0 20px;
		
			.pop-header {
				height: 56px;
				display: flex;
				align-items: center;
				position: relative;
				border-bottom: 1px solid #EDEDED;
		
				.ph-title {
					font-size: 16px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					line-height: 16px;
				}
		
				.ph-close {
					width: 16px;
					height: 16px;
					background-image: url('../assets/058.png');
					background-size: 100% 100%;
					position: absolute;
					right: 0;
				}
			}
		
			.pop-body {
				box-sizing: border-box;
				padding: 0 0 20px;
				display: flex;
				flex-direction: column;
		
				.cb-row {
					display: flex;
					align-items: center;
					margin: 20px 0 0;
					.cbr-label {
						width: 100px;
						display: flex;
						// justify-content: flex-end;
						font-size: 14px;
						font-family: Microsoft YaHei, Microsoft YaHei;
						font-weight: 400;
						color: #333333;
						box-sizing: border-box;
						padding-right: 10px;
					
						.star {
							color: #FF0000;
						}
					}
					
					.cbr-content {
						flex: 1;
						display: flex;
						// align-items: center;
						
						.upload-demo {
							
							// background: #FFFFFF;
							// width: 100px;
							// height: 100px;
							// overflow: hidden;
							// border-radius: 4px;
							// box-shadow: 0px 2px 8px 0px rgba(203, 203, 203, 0.5);
							margin-right: 10px;
							
							::v-deep {
								.el-upload-list--picture-card .el-upload-list__item {
									width: 100px;
									height: 100px;
								}
							}
									
							.zhizhao-upload {
								width: 100px;
								height: 100px;
								background: #F6F8FC;
								border-radius: 4px 4px 4px 4px;
								box-sizing: border-box;
								border: 1px dashed #3571DA;
								display: flex;
								flex-direction: column;
								justify-content: center;
								align-items: center;
									
								.zu-icon {
									width: 28px;
									height: 28px;
									background-image: url('../assets/043.png');
									background-size: 100% 100%;
								}
									
								.zu-label {
									margin-top: 8px;
									font-size: 12px;
									font-family: Microsoft YaHei, Microsoft YaHei;
									font-weight: 400;
									color: #8D9094;
									line-height: 16px;
								}
							}
						}
						
						.cbrc-value {
							font-size: 12px;
							font-family: Microsoft YaHei, Microsoft YaHei;
							font-weight: 400;
							color: #333333;
						}
						
						.yanzhengma {
							position: relative;
							.yanzhengma-btn {
								position: absolute;
								right: 0;
								top: 0;
								font-size: 12px;
								font-family: Microsoft YaHei, Microsoft YaHei;
								font-weight: bold;
								color: #3571DA;
								line-height: 32px;
								width: 80px;
								text-align: center;
							}
						}
						
						::v-deep.input {
							input {
								height: 32px;
								font-size: 12px;
								font-family: Microsoft YaHei, Microsoft YaHei;
								font-weight: 400;
								color: #333333;
								padding-left: 8px;
							}
						
							&.type-1 {
								width: 320px;
							}
						}
					}
				}
				
			}
		
			.pop-footer {
				border-top: 1px solid #EDEDED;
				height: 72px;
				display: flex;
				justify-content: center;
				align-items: center;
		
				.pf-cancel {
					width: 88px;
					height: 32px;
					border-radius: 4px 4px 4px 4px;
					opacity: 1;
					border: 1px solid #3571DA;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #3571DA;
					line-height: 14px;
					box-sizing: border-box;
					margin: 0 10px;
				}
		
				.pf-confirm {
					width: 88px;
					height: 32px;
					background: #3571DA;
					border-radius: 4px 4px 4px 4px;
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #FFFFFF;
					line-height: 32px;
					text-align: center;
					margin: 0 10px;
				}
			}
		}
	}
</style>